import { AemManifestPage } from '@mercedes-benz/plugin-seamless';

export const AemManifestTab = () => <AemManifestPage />;
